import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LayoutGridIcon } from '../../../icons/animated';

export interface AppsDockTriggerProps {
  onClick: () => void;
  isOpen?: boolean;
}

export const AppsDockTrigger: React.FC<AppsDockTriggerProps> = ({
  onClick,
  isOpen = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const isMac = typeof navigator !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
  const shortcutHint = isMac ? '⌘+Space' : 'Ctrl+Space';

  return (
    <motion.button
      type="button"
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.94 }}
      transition={{ type: 'spring', stiffness: 400, damping: 25 }}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label="Applications Launcher"
      title={`Applications Launcher (${shortcutHint} or Ctrl+Space)`}
      className={`relative group flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-xl transition-all duration-200 focus:outline-none ${isOpen
        ? 'bg-[var(--navbar-btn-hover,rgba(255,255,255,0.3))] border border-[var(--navbar-btn-border,rgba(255,255,255,0.6))] text-[var(--navbar-text,#ffffff)] shadow-lg backdrop-blur-md'
        : 'bg-[var(--navbar-btn-bg,rgba(255,255,255,0.1))] hover:bg-[var(--navbar-btn-hover,rgba(255,255,255,0.2))] border border-[var(--navbar-btn-border,rgba(255,255,255,0.2))] text-[var(--navbar-text,#ffffff)] shadow-sm hover:shadow-md backdrop-blur-md'
        }`}
    >
      <LayoutGridIcon size={20} isHovered={isHovered} className="text-[var(--navbar-text,#ffffff)] drop-shadow-sm" />

      {/* Subtle active status indicator */}
      {isOpen && (
        <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-emerald-400 ring-2 ring-emerald-950 animate-pulse" />
      )}
    </motion.button>
  );
};
